import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=50a5f18e&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a5f18e')) {
      api.createRecord('50a5f18e', component.options)
    } else {
      api.reload('50a5f18e', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=50a5f18e&", function () {
      api.rerender('50a5f18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClientLocation/Modal.vue"
export default component.exports